import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import mobile from '../../components/isMobile.vue';
import hysbwg from '../../components/hysbwg.vue';
export default {
  name: 'new3DList',
  meta: {
    keepAlive: false
  },
  data() {
    return {
      stageUrl: '',
      listPage: 1,
      list: [],
      config: {},
      columns: [],
      keyword: '',
      columnIndex: 0,
      pageNum: 0,
      isLoading: true,
      pageType: 'white',
      //white白金 black黑金
      isMobile: false,
      types: ['3D', '360', '视频', '图片'],
      a_type: 0,
      paramsData: {},
      gdbg: require('@/assets/standard3d/bg.png'),
      typesShow: true
    };
  },
  components: {
    mobile,
    hysbwg
  },
  methods: {
    changeList() {
      this.$router.push({
        name: 'springwaterList',
        query: this.$route.query
      });
    },
    toDetail(data) {
      let params = {
        column: this.columns[this.columnIndex].columnName,
        type: this.types[this.a_type - 1],
        keyword: this.keyword,
        page: this.listPage,
        index: this.list.findIndex(i => {
          return i.code == data.code;
        })
      };
      let url = this.$route.query.type == 'luoshen' ? 'springwaterDetail' : 'new3DDetail';
      let query = {
        fid: this.$route.query.fid,
        code: data.code,
        type: this.$route.query.type
      };
      query.fy = this.$route.query.fy || undefined;
      if (params.page) {
        window.sessionStorage.setItem("searchKey", JSON.stringify(params));
      }
      data.autoCode ? query.autoCode = data.autoCode : data.m_index ? query.index = data.m_index : '';
      this.$router.push({
        name: url,
        query,
        params: params
      });
    },
    // 改变栏目
    changeColumn(index) {
      this.columnIndex = index;
      this.listPage = 1;
      this.getList();
    },
    // 滚动事件
    scrollEvent(e) {
      if (e.srcElement.scrollTop + e.srcElement.clientHeight >= e.srcElement.scrollHeight - 100) {
        if (this.isLoading) return;
        if (this.pageNum == this.listPage) return;
        this.listPage = this.listPage + 1;
        this.getList();
      }
    },
    // 获取页面配置
    getConfig(type) {
      let singleform = {
        limit: 100,
        page: 1
      };
      singleform.fid = this.$route.query.fid || '151066';
      singleform.formId = '112706';
      this.$api.singleformList(singleform).then(res => {
        let data = res.data[0];
        this.config = {
          title: this.getConfigInFormData(data.formData, 'title'),
          logo: this.getConfigInFormData(data.formData, 'logo', 'img')
        };
        document.title = this.config.title || '文物综合展示系统';
      });
    },
    // 文物列表
    getList(type, index) {
      if (type == 'types') {
        this.a_type = this.a_type == index ? 0 : index;
      }
      if (type && type != 'types') this.a_type = 0;
      if (type) this.listPage = 1;
      this.isLoading = true;
      if (this.listPage == 1) this.list = [];
      // 客家赣州定制数据来源文物基本信息表单
      if (this.$route.query.fid == 328720 && !this.a_type) {
        let limit;
        if (this.isMobile) limit = parseInt(this.$refs.listWarp.clientHeight / (0.282 * window.innerWidth + 40)) * 3 + 3;
        console.log(this.$refs.listWarp.clientHeight / 90, limit, 'limit');
        return this.getGzList(type, index, limit);
      }
      let query = {
        deptId: this.$route.query.fid || '151066',
        formId: 113010,
        page: this.listPage,
        limit: window.innerWidth == 1080 ? 50 : this.isMobile ? 15 : 20,
        searchStr: '',
        orderBy: 'manualOrderTop,manualOrder',
        orderType: 'desc'
      };
      if (this.columnIndex > 0 || this.a_type || this.keyword) {
        let a = {
          filters: [],
          model: 0
        };
        if (this.columnIndex > 0) {
          a.filters.push([{
            alias: this.$route.query.fid == 200375 ? 'columns' : "column",
            compt: "selectbox",
            express: "match",
            range: null,
            val: [this.columns[this.columnIndex].columnName]
          }]);
        }
        if (this.keyword) {
          a.filters.push([{
            alias: "antiqueName",
            compt: "selectbox",
            express: "like",
            id: 1,
            range: null,
            val: [this.keyword]
          }]);
        }
        if (this.a_type) {
          a.filters.push([{
            alias: "type",
            compt: "selectbox",
            express: "like",
            id: 29,
            range: null,
            val: [this.types[this.a_type - 1]]
          }]);
        }
        console.log(a, 111);
        query.searchStr = encodeURI(JSON.stringify(a));
      }
      this.$api.singleadvanceSearch(query).then(res => {
        this.pageNum = res.totalPage;
        let list = res.dataList.map((item, index) => {
          let nItem = {
            columnName: this.$route.query.fid == 200375 ? this.getValInFormData(item.formIdValueData, 'columns') : this.getValInFormData(item.formIdValueData, 'column'),
            name: this.getValInFormData(item.formIdValueData, 'antiqueName'),
            img: this.getValInFormData(item.formIdValueData, 'thumbnail', 'img'),
            code: this.getValInFormData(item.formIdValueData, 'autoId'),
            type: this.getValInFormData(item.formIdValueData, 'type'),
            index: index,
            autoCode: this.getValInFormData(item.formIdValueData, 'autoCode'),
            m_index: 0,
            showType: this.getValInFormData(item.formIdValueData, 'showType')
          };
          return nItem;
        });
        // 手动塞重复数据的index，兼容旧数据
        list.map(item => {
          if (list.filter(l => {
            return l.code == item.code;
          }).length > 1) {
            let f_list = list.filter(l => {
              return l.code == item.code;
            });
            f_list.map((f, i) => {
              list[f.index].m_index = i;
            });
          }
        });
        this.list = this.list.concat(list.filter(item => {
          return item.showType.indexOf('电脑端与移动端') > -1;
        }));
        console.log(this.isMobile, 'isMobile');
        if (this.isMobile) {
          // 列表和分页参数存到storage
          window.sessionStorage.setItem('wzList', JSON.stringify(this.list));
          window.sessionStorage.setItem('wzFid', JSON.stringify(this.$route.query.fid));
          window.sessionStorage.setItem('wzPage', JSON.stringify({
            pageNum: this.pageNum,
            listPage: this.listPage
          }));
        }
        this.isLoading = false;
      });
    },
    getGzList(index, type, limit) {
      let query = {
        deptId: this.$route.query.fid || '151066',
        formId: 112720,
        page: this.listPage,
        limit: limit || 20,
        searchStr: '',
        orderBy: 'manualOrderTop,manualOrder',
        orderType: 'desc'
      };
      if (this.columnIndex > 0 || this.keyword) {
        let a = {
          filters: [],
          model: 0
        };
        if (this.columnIndex > 0) {
          a.filters.push([{
            alias: 33,
            compt: "selectbox",
            express: "match",
            range: null,
            val: [this.columns[this.columnIndex].columnName]
          }]);
        }
        if (this.keyword) {
          a.filters.push([{
            alias: "antiqueName",
            compt: "selectbox",
            express: "like",
            id: 1,
            range: null,
            val: [this.keyword]
          }]);
        }
        console.log(a, 222);
        query.searchStr = encodeURI(JSON.stringify(a));
      }
      this.$api.singleadvanceSearch(query).then(res => {
        this.pageNum = res.totalPage;
        let list = res.dataList.map((item, index) => {
          let nItem = {
            columnName: this.getValInFormData(item.formIdValueData, 33),
            name: this.getValInFormData(item.formIdValueData, 'antiqueName'),
            img: this.getValInFormData(item.formIdValueData, 'thumbPath', 'img'),
            code: this.getValInFormData(item.formIdValueData, 'autoId'),
            m_index: 0
          };
          return nItem;
        });
        this.list = this.list.concat(list);
        if (this.isMobile) {
          // 列表和分页参数存到storage
          window.sessionStorage.setItem('wzList', JSON.stringify(this.list));
          window.sessionStorage.setItem('wzFid', JSON.stringify(this.$route.query.fid));
          window.sessionStorage.setItem('wzPage', JSON.stringify({
            pageNum: this.pageNum,
            listPage: this.listPage
          }));
        }
        this.isLoading = false;
      });
    },
    //获取栏目列表
    getColumn() {
      let query = {
        deptId: this.$route.query.fid || '151066',
        formId: 112712,
        page: 1,
        limit: 50,
        orderBy: 'manualOrderTop,manualOrder',
        orderType: 'desc'
      };
      this.$api.singleadvanceSearch(query).then(res => {
        this.columns = res.dataList.map(item => {
          let nItem = {
            columnName: item.formIdValueData.name.groupValues[0] ? item.formIdValueData.name.groupValues[0].values[0][0].val : ''
          };
          return nItem;
        });
        this.columns.unshift({
          columnName: '全部'
        });
        if (this.paramsData.page) {
          this.keyword = this.paramsData.keyword;
          this.columnIndex = this.columns.findIndex(item => {
            return item.columnName == this.paramsData.column;
          }) > -1 ? this.columns.findIndex(item => {
            return item.columnName == this.paramsData.column;
          }) : 0;
          this.a_type = this.types.findIndex(item => {
            return item == this.paramsData.type;
          }) + 1;
        }
        // 从缓存里取数据
        if (window.sessionStorage.getItem('wzList') && JSON.parse(window.sessionStorage.getItem('wzFid')) == this.$route.query.fid && this.isMobile) {
          this.list = JSON.parse(window.sessionStorage.getItem('wzList'));
          let wzPage = JSON.parse(window.sessionStorage.getItem('wzPage'));
          this.pageNum = parseInt(wzPage.pageNum);
          this.listPage = parseInt(wzPage.listPage);
          return this.isLoading = false;
        }
        this.a_type > 0 || this.keyword ? this.getList('types', this.a_type) : this.getList();
      });
    },
    getValInFormData(data, id, type, index) {
      index = index ? index : 0;
      if (!data[id] || !data[id].groupValues[index] || !data[id].groupValues[index].values[0].length) {
        return '';
      }
      let target;
      if (type && type == 'img') {
        if (!data[id].groupValues[index].values[0][0]) return '';
        target = process.env.NODE_ENV == 'development' ? data[id].groupValues[index].values[0][0] : data[id].groupValues[index].values[0][0].fileUrl;
        target = target && process.env.NODE_ENV != 'development' ? target.replace('http:', 'https:') : `https://museum.chaoxing.com/star3/origin/${target.objectId}.${target.suffix}`;
      } else {
        target = type ? data[id].groupValues[index].values[0][0][type] : data[id].groupValues[index].values[0][0].val;
      }
      return target;
    },
    getConfigInFormData(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      });
      if (!target) return '';
      target = target.values[0];
      if (!target) return '';
      target.file = process.env.NODE_ENV == 'development' ? `https://museum.chaoxing.com/star3/origin/${target.objectId}.${target.suffix}` : target.fileUrl ? target.fileUrl.replace('http:', 'https:') : '';
      return type ? target.file : target.val;
    }
  },
  created() {
    this.pageType = this.$route.query.type || 'white';
    this.stageUrl = process.env.VUE_APP_IMG_URL;
    this.getConfig();
    this.paramsData = window.sessionStorage.getItem("searchKey") ? JSON.parse(window.sessionStorage.getItem("searchKey")) : {};
  },
  mounted() {
    /* 广德博物馆 背景定制 换成标准版背景 */
    if (Number(this.$route.query.fid) === 239301 && this.pageType === 'white') {
      this.$refs['new3DList'].style.background = `url('${this.gdbg}') 0 0/100% 100% no-repeat`;
    }
    /* 昆山市文体广电和旅游局 铂金版 去掉类型 */
    if (Number(this.$route.query.fid) === 254023 && this.pageType === 'white') this.typesShow = false;
    this.getColumn();
  },
  beforeRouteEnter(to, from, next) {
    console.log(to, from);
    next(vm => {
      if (from.name == "new3DDetail") {
        // location.reload()
      }
    });
  }
};